/** "G then a letter" shortcuts: while one is pending, the list leaves the letter alone. */
let gAt = 0;
export function markG() { gAt = Date.now(); }
export function gPending(): boolean { return Date.now() - gAt < 1200; }
export function clearG() { gAt = 0; }
